<div class="modal-content">

  <div class="common-header-flex">
    <div>Create Workspace</div>
    <button>
      <span class="common-close" (click)="modelhide()">&times;</span>
    </button>
  </div>

  <div class="modal-body padding-rl">
    <div [formGroup]="teamForm">
      <div class="app-form">
        <div class="row ">
          <div class="col-md-8 discol">
            <div class="form-group mt-10">
              <label for="teamName" class="required">Workspace Name</label>
              <div>
                <input maxlength="31" type="text" class="form-control input-sm" formControlName="teamName"
                  placeholder="Please Enter a Workspace Name" trim="blur" />
                <div *ngIf="(submit && f.teamName.invalid) || (f.teamName.invalid && (f.teamName.dirty || f.teamName.touched))" class="error-msg">
                  <div class="red" *ngIf="f.teamName.errors?.pattern">{{ FORMERROR.TEAMNAME_PATTERN }}</div>
                  <div class="red" *ngIf="f.teamName.errors?.required">Workspace name is required</div>
                  <div class="red" *ngIf="f.teamName.errors?.minLetters">{{FORMERROR.TEAMNAME_MIN}}</div>
                  <div class="red" *ngIf="f.teamName.errors?.maxLetters">{{FORMERROR.TEAMNAME_MAX}}</div>
                </div>
              </div>
            </div>

            <div>
              <div class="mt-10">
                <label for="">Workspace Logo</label>
              </div>
              <div>
                <input type="file" class="form-control input-sm" accept=".jpg, .jpeg, .png" #myFileInput
                  (change)="fileChangeEvent($event, template)" (click)="resetFileId()" />

              </div>
            </div>

            <div class="mt-10">
              <label for="Current Organization" class="required">Current Organization</label>
              <input class="form-control input-sm" type="text" formControlName="organizationId">
              <div>

                <div class="mt-10">
                  <label class="required" for="">Add Members</label>
                </div>
                <div>

                  <ng-select class="multiselectlable" [multiple]="true" [items]="conditionList" [hideSelected]="false" [closeOnSelect]="false"
                    [(ngModel)]="conditionSelectedItems" name="licenseAuthorityId" bindValue="userId" bindLabel="userName"
                    formControlName="addconnection" placeholder="Add members">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="ng-select-checkbox-label">
                        <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                        <img *ngIf="item.photo!=null && item.photo!=undefined" class="img-show-hide"
                          src="{{url+item.photo}}">
                        <div *ngIf="!item?.photo">
                          <div class="circleimg-show-hide" [style.background-color]="getColortwo(item?.firstName,item.lastName)">
                            <div class="circle-text" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{ getInitialstwo(item?.firstName,item.lastName) }}</div>
                          </div>
                        </div>
                        <span class="ng-select-checkbox-text" [attr.title]="item.userName">{{item.userName}}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                      <div class="selected-item" [attr.title]="item.userName">
                        <span class="ng-value-clear remove-icon" (click)="clear(item)">
                          ✕
                        </span>
                        <span class="ng-value-label">{{ item.userName }}</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div *ngIf="(submit && f.addconnection.invalid) ||
                (f.addconnection.invalid &&
                  (f.addconnection.dirty ||
                    f.addconnection.touched))">

                  <div *ngIf="f.addconnection.errors" style="color:#c3002f;float: right;">
                    At least one member is required
                  </div>
                </div>
              </div>
              <div>
                <div class="mt-10">
                  <label for="">Description</label>
                </div>
                <div>
                  <div class="form-group R-summary">
                    <textarea class="form-control input-sm" placeholder="Description" [ngxSummernote]="config"
                      formControlName="description" name="" id="" rows="3"></textarea>
                    <div class="error-msg" *ngIf="f.description.invalid ">
                      <div *ngIf="f.description.errors.minchar ">
                        {{FORMERROR.ABOUT_YOUR_MIN}}
                      </div>
                      <div *ngIf="f.description.errors.maxchar">
                        {{FORMERROR.ABOUTME_MAX}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-4 pd-tp-2rem">
            <div>
              <h5 class="fw-bold-1" for="">How it works?</h5>
            </div>
            <div>
              <p>
                You can create Workspace and add your colleagues to
                specific Workspace.
              </p>
              <p>
                You can connect, share and collaborate within the specific Workspace as a group.
              </p>
            </div>
            <!-- <div style="text-align: center;">
              <img src="assets/icon/img.png" alt="" srcset="" />
            </div> -->
            <ng-icon name="customTeamColor" class="top-12"></ng-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button type="button" class="btn btn-default m-r-6" (click)="modelhide()">
            Cancel
          </button>
          <button type="button" class="btn primary-btn  btn-pri m-r-20" (click)="save()">
            Create
          </button>
        </div>
      </div>
    </div>

  </div>
</div>


<ng-template #template>


  <div class="common-header-flex">
    <div>Workspace Logo</div>
    <button>
      <span class="common-close" (click)="closePhoto()">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" format="jpeg"
      [roundCropper]="false" [resizeToWidth]="200" [resizeToHeight]="200"
      (imageCropped)="imageCropped($event)"></image-cropper>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
        <button class="btn btn-primary" (click)="imageLoaded()">Apply</button>
      </div>
    </div>
  </div>

</ng-template>
